import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { GROWTHBOOK_FEATURE_FLAGS } from '@web-app/constants/growthbook';
import { useGroupPracticeInvoiceEnabled } from '@web-app/utils/feature-flags/group-practice-invoice';
import { useRouter } from 'next/router';

/**
 * Hook to determine if the Sub-Orgs Invoice Review page should be enabled.
 *
 * The GrowthBook flag uses excluded orgs targeting — orgs not in the
 * exclusion list receive the feature.
 *
 * Hidden when the Group Practice page is enabled (they are mutually exclusive).
 *
 * Priority (highest to lowest):
 * 1. Group Practice enabled → always hidden
 * 2. URL query parameter ?useSubOrgsInvoiceReview=true|false
 * 3. GrowthBook feature flag 'sub-orgs-invoice-review-exclude'
 */
export const useSubOrgsInvoiceReviewEnabled = (): boolean => {
  const router = useRouter();
  const groupPracticeEnabled = useGroupPracticeInvoiceEnabled();
  
  if (groupPracticeEnabled) {
    return false;
  }
  const growthBookEnabled = useFeatureIsOn(
    GROWTHBOOK_FEATURE_FLAGS.SUB_ORGS_INVOICE_REVIEW_EXCLUDE,
  );

  // Query param override for testing
  const queryParam = router.query['useSubOrgsInvoiceReview'];
  if (queryParam === 'true') {
    return true;
  }
  if (queryParam === 'false') {
    return false;
  }

  return growthBookEnabled;
};
